<link rel="ractive" href="./select.html" name="c-select">
<link rel="ractive" href="./probe-single-card.html" name="c-probe-single-card">
<link rel="ractive" href="./probe-filters.html" name="c-probe-filters">
<link rel="ractive" href="./probe-loading-state.html" name="c-probe-loading-state">

<div class="gp-filtered-list">
	<c-probe-filters
		rawProbes="{{rawProbes}}"
		location="{{location}}"
		locationError="{{locationError}}"
		locationProbes="{{locationProbes}}"
		locationCompletedValue="{{locationCompletedValue}}"
		ttPositions="{{ttPositions}}"
		groupingOptions="{{groupingOptions}}"
		groupBy="{{groupBy}}"
		sortOptions="{{sortOptions}}"
		sortOrder="{{sortOrder}}"
	/>

	{{#if preparedProbeBlocks && preparedProbeBlocks.length > 0}}
		<p class="gp-filtered-list_result-count">
			<span>
				Showing <b>{{totalResults}} unique {{_.pluralize('result', totalResults)}}</b>{{#if groupBy === 'network'}}.{{/if}}

				{{#if groupBy === 'country'}}
					from <b>{{probeLocationCounts.continent}} {{_.pluralize('continent', probeLocationCounts.continent)}}</b>.
				{{elseif groupBy === 'city' || groupBy === 'country-network'}}
					from <b>{{probeLocationCounts.country}} {{_.pluralize('country', 'countries', probeLocationCounts.country)}}</b>
					and <b>{{probeLocationCounts.continent}} {{_.pluralize('continent', probeLocationCounts.continent)}}</b>.
				{{elseif groupBy === 'city-network' || groupBy === 'disabled'}}
					from <b>{{probeLocationCounts.city}} {{_.pluralize('city', 'cities', probeLocationCounts.city)}}</b>,
					<b>{{probeLocationCounts.country}} {{_.pluralize('country', 'countries', probeLocationCounts.country)}}</b>,
					and <b>{{probeLocationCounts.continent}} {{_.pluralize('continent', probeLocationCounts.continent)}}</b>.
				{{/if}}
			</span>

			{{#if hasCustomLocationApplied}}
				<button type="button" on-click="@this.resetFilters()" tabindex="0">
					Show all
				</button>
			{{/if}}
		</p>
	{{/if}}

	{{#if probeContinents.length > 1}}
		<div class="gp-filtered-list_jump">
			<div class="gp-filtered-list_jump_field">
				<label>Jump to</label>
				<c-select
					options="{{probeContinents}}"
					selected="{{selectedContinent}}"
					placeholder="Choose continent"
					onSelect="{{@this.scrollToContinent}}"
					name="jump-to-select"
				/>
			</div>
		</div>
	{{/if}}

	<div class="gp-filtered-list_list {{groupBy === 'disabled' ? 'disabled-group-by' : ''}}">
		<c-probe-loading-state
			loading="{{probesLoading}}"
			error="{{probesError}}"
			hasData="{{locationProbes.length}}"
			filter="{{filter}}"
		/>
		{{#if preparedProbeBlocks.length}}
			{{#each preparedProbeBlocks as block}}
				<div class="gp-filtered-list_list_block group-by-{{groupBy}}">
					{{#if groupBy === 'disabled'}}
						{{#each visibleProbeCards as item : index}}
							<c-probe-single-card
								location="{{item.location}}"
								tags="{{item.tags}}"
								render="{{!loadingProbeCards || index < defaultCardRenderLimit}}"
								screenWidth="{{screenWidth}}"
								locationFilter="{{~/location}}">
							</c-probe-single-card>
						{{/each}}
						{{#if visibleProbeCards.length < block.items.length || loadingProbeCards}}
							<button type="button" on-click="@this.showAllProbeCards()" {{#if loadingProbeCards}}disabled{{/if}}>
								{{#if loadingProbeCards}}
									<i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
								{{/if}}
								Show all
							</button>
						{{/if}}
					{{else}}
						<div class="gp-filtered-list_list_block_group group-by-{{groupBy}}" data-testid="probe-block-group">
							{{#if block.title}}
								<span class="gp-filtered-list_list_block_group_item cont-header" id="probe-group-{{block.title}}">
									<img width="24" height="24" src="{{@shared.assetsHost}}/img/network/continent-{{block.title.toLowerCase()}}.svg" alt="" aria-hidden="true">
									{{@this.getContinentName(block.title)}}
								</span>
							{{/if}}
							{{#each block.items as item}}
								{{#if item.networks && item.networks.length}}
									<div class="gp-filtered-list_list_block_group_networks-item">
										<span class="gp-filtered-list_list_block_group_networks-item_country">
											<img loading="lazy"
												width="17"
												height="20"
												alt=""
												aria-hidden="true"
												src="https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/{{item.location.split(', ')[0]}}.svg">
											<span class="gp-filtered-list_popover-root"
												tabindex="0"
												role="button"
												as-popover="@this.getPopoverContent(item.from)">
												{{item.name}}
											</span>
										</span>
										<div class="gp-filtered-list_list_block_group_networks-item_networks">
											{{#each item.networks}}
												<span class="gp-filtered-list_popover-root"
													tabindex="0"
													role="button"
													as-popover="@this.getPopoverContent(item.from, this.name)">
													<span class="gp-filtered-list_list_block_group_networks-item_network">
														{{name}}{{#if count > 1}} (x{{this.count}}){{/if}}
													</span>
												</span>
											{{/each}}
										</div>
									</div>
								{{else}}
									<div class="gp-filtered-list_list_block_group_item gp-filtered-list_popover-root"
										tabindex="0"
										role="button"
										as-popover="@this.getPopoverContent(item.from)"
									>
										{{#if item.showFlag}}
											<img loading="lazy"
												width="17"
												height="20"
												alt=""
												aria-hidden="true"
												src="https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/{{item.location.split(', ')[0]}}.svg">
										{{elseif groupBy === 'network'}}
											<span class="gp-filtered-list_network-logo">
												{{#if item.logoAsn}}
													<img width="20"
														height="20"
														src="/asn-logo/AS{{item.logoAsn}}?v={{@shared.assetsVersion}}&size=40"
														loading="lazy"
														alt=""
														aria-hidden="true"
														on-error="@this.onLogoError(item)"
													>
												{{else}}
													{{item.name[0]}}
												{{/if}}
											</span>
										{{/if}}
										<span class="gp-filtered-list_list_block_group_item_location">
											{{item.name}}
										</span>
										<span class="gp-filtered-list_list_block_group_item_count">{{item.probes.length}}</span>
									</div>
								{{/if}}
							{{/each}}
						</div>
					{{/if}}
				</div>
			{{/each}}
		{{/if}}
	</div>

	{{#if groupBy === 'network'}}
		<div class="gp-filtered-list_logos-by">
			<a href="https://logo.dev" target="_blank" rel="noreferrer">Network logos provided by Logo.dev</a>
		</div>
	{{/if}}
</div>

<script>
	const popover = require('../../assets/js/decorators/popover');
	const _ = require('../../assets/js/_');
	const listeners = require('../../assets/js/utils/listeners');

	const CONTINENTS = require('../../assets/json/continents.json');
	const COUNTRIES = require('../../assets/json/countries.json');
	const DEFAULT_CARD_RENDER_LIMIT = 99;

	const CONTINENT_MAP = CONTINENTS.reduce((acc, continent) => {
		acc[continent.code] = continent.name;
		return acc;
	}, {});

	const COUNTRIES_MAP = COUNTRIES.reduce((acc, country) => {
		acc[country.code] = country.name;
		return acc;
	}, {});

	component.exports = {
		decorators: {
			popover,
		},
		data () {
			return {
				_,
				locationError: '',
				groupingOptions: [
					{
						name: 'Country',
						value: 'country',
					},
					{
						name: 'City',
						value: 'city',
					},
					{
						name: 'Network',
						value: 'network',
					},
					{
						name: 'Country + Network',
						value: 'country-network',
					},
					{
						name: 'City + Network',
						value: 'city-network',
					},
					{
						name: 'Disabled',
						value: 'disabled',
					},
				],
				sortOptions: [
					{
						name: 'Alphabetically',
						value: 'alphabetically',
					},
					{
						name: 'Probe count',
						value: 'probe-count',
					},
				],
				defaultSortOptions: {},
				probeContinents: [],
				groupedProbes: null,
				locationProbes: null,
				preparedProbeBlocks: null,
				filteredMarkersData: null,
				selectedContinent: null,
				justClickedLocationFocus: false,
				skipNextSplit: false,
				hasManualSortBy: false,
				preFocusGroupBy: null,
				autoGroupedByFocus: false,
				isProgrammaticGroupByChange: false,
				visibleProbeCards: [],
				defaultCardRenderLimit: DEFAULT_CARD_RENDER_LIMIT,
				probeCardTimeout: null,
				loadingProbeCards: false,
				screenWidth: 0,
			};
		},
		computed: {
			probeLocationCounts () {
				let probes = this.get('locationProbes');

				if (!probes) {
					return {
						continent: 0,
						country: 0,
						city: 0,
						network: 0,
					};
				}

				let uniqueValues = probes.reduce((acc, probe) => {
					acc.continent.add(probe.location.continent);
					acc.country.add(probe.location.country);
					acc.city.add(probe.location.country + probe.location.city);
					acc.network.add(probe.location.network);
					return acc;
				}, { continent: new Set(), country: new Set(), city: new Set(), network: new Set() });

				return {
					continent: uniqueValues.continent.size,
					country: uniqueValues.country.size,
					city: uniqueValues.city.size,
					network: uniqueValues.network.size,
				};
			},
			totalResults () {
				let probes = this.get('locationProbes');
				let groupBy = this.get('groupBy');

				if (!probes) {
					return 0;
				}

				if (groupBy === 'disabled') {
					return probes.length;
				}

				// do not recalculate the total if we already have it in probeLocationCounts
				if (!groupBy.includes('-')) {
					return this.get('probeLocationCounts')[groupBy];
				}

				let keyParts = {
					'country-network': [ 'country', 'network' ],
					'city-network': [ 'country', 'city', 'network' ],
				}[groupBy];

				return probes.reduce((uniqueKeys, probe) => {
					uniqueKeys.add(keyParts.map(part => probe.location[part]).join());
					return uniqueKeys;
				}, new Set()).size;
			},
			hasCustomLocationApplied () {
				let location = this.get('location');
				return location && location.toLowerCase() !== 'world';
			},
		},
		oninit () {
			if (!Ractive.isServer) {
				// set initial screenWidth value
				this.observe('screenWidth', (screenWidth) => {
					if (!screenWidth) {
						this.set('screenWidth', window.innerWidth);
						return;
					}

					// handle tooltips positions depending on the screen size
					let ttPositions = {};

					if (screenWidth >= 1272) {
						ttPositions.targetTtPos = 'top';
						ttPositions.locationTtPos = 'top';
						ttPositions.limitTtPos = 'top';
					} else if (screenWidth >= 768) {
						ttPositions.targetTtPos = 'top';
						ttPositions.locationTtPos = 'right';
						ttPositions.limitTtPos = 'top';
					} else {
						ttPositions.targetTtPos = 'right';
						ttPositions.locationTtPos = 'right';
						ttPositions.limitTtPos = 'right';
					}

					this.set('ttPositions', ttPositions);
				});

				this.observe('locationProbes', (locationProbes) => {
					this.set('filteredProbes', locationProbes);

					// we need to set sort, filter, and group query params simultaneously
					let payload = {};
					let doAtomicUpdate = false;
					let nextGroupBy = this.get('groupBy');

					if (this.get('justClickedLocationFocus')) {
						this.set('justClickedLocationFocus', false);

						if (!this.get('autoGroupedByFocus')) {
							this.set('preFocusGroupBy', this.get('groupBy'));
						}

						let { cities, countries, networks } = this.getLocationCounts(locationProbes || []);
						let newGroupBy = null;

						if (cities + countries + networks === 3) {
							newGroupBy = 'disabled';
						} else if (cities + countries === 2) {
							newGroupBy = 'network';
						} else if (cities > 1) {
							newGroupBy = 'city';
						}

						if (newGroupBy && newGroupBy !== this.get('groupBy')) {
							this.set('isProgrammaticGroupByChange', true);
							nextGroupBy = newGroupBy;

							payload = {
								groupBy: newGroupBy,
								locationCompletedValue: this.get('location'),
								autoGroupedByFocus: true,
							};

							doAtomicUpdate = true;
						}
					} else {
						// restore previous groupBy value if the current groupBy value was set via "focus this location"
						if (this.get('autoGroupedByFocus')) {
							let previousGroupBy = this.get('preFocusGroupBy');

							if (previousGroupBy && previousGroupBy !== this.get('groupBy')) {
								this.set('isProgrammaticGroupByChange', true);
								nextGroupBy = previousGroupBy;

								payload = {
									groupBy: previousGroupBy,
									locationCompletedValue: this.get('location'),
								};

								doAtomicUpdate = true;
							}

							this.set('autoGroupedByFocus', false);
							this.set('preFocusGroupBy', null);
						}
					}

					if (doAtomicUpdate) {
						let defaultSort = this.get('defaultSortOptions')[nextGroupBy];

						if (nextGroupBy !== 'disabled' && defaultSort && this.get('sortOrder') !== defaultSort && !this.get('hasManualSortBy')) {
							payload.skipNextSplit = true;
							payload.sortOrder = defaultSort;
						}

						this.set(payload);
					}

					let groupedProbes = this.groupProbes(locationProbes || []);
					this.set('groupedProbes', groupedProbes);
				});

				this.observe('groupBy', (groupBy) => {
					if (this.get('isProgrammaticGroupByChange')) {
						this.set('isProgrammaticGroupByChange', false);
						return;
					}

					this.set('autoGroupedByFocus', false);
					this.set('preFocusGroupBy', null);

					let defaultSort = this.get('defaultSortOptions')[groupBy];

					if (groupBy !== 'disabled' && defaultSort && this.get('sortOrder') !== defaultSort && !this.get('hasManualSortBy')) {
						this.set('skipNextSplit', true);
						this.set('sortOrder', defaultSort);
					}

					let locationProbes = this.get('locationProbes');
					let groupedProbes = this.groupProbes(locationProbes || []);

					this.set('groupedProbes', groupedProbes);
				}, { init: false });

				this.observe('sortOrder', (sortOrder) => {
					let groupBy = this.get('groupBy');

					if (groupBy === 'disabled') {
						return;
					}

					let defaultSort = this.get('defaultSortOptions')[groupBy];

					if (sortOrder === defaultSort) {
						this.set('hasManualSortBy', false);
					} else {
						this.set('hasManualSortBy', true);
					}
				});

				this.observe('groupedProbes', () => {
					this.recalculateProbeContinents();
				});

				this.observe('groupBy location', () => {
					clearTimeout(this.probeCardTimeout);
					this.set('loadingProbeCards', false);
				});

				this.observe('groupedProbes sortOrder screenWidth', () => {
					if (this.get('skipNextSplit')) {
						this.set('skipNextSplit', false);
						return;
					}

					let preparedProbeBlocks = this.splitDataIntoBlocks();
					this.set('preparedProbeBlocks', preparedProbeBlocks);

					if (this.get('groupBy') === 'disabled' && preparedProbeBlocks.length > 0) {
						this.set('visibleProbeCards', preparedProbeBlocks[0].items.slice(0, this.get('defaultCardRenderLimit')));
					}
				});
			}
		},
		onrender () {
			if (!Ractive.isServer) {
				listeners.screenWidthListener(this);

				let handleFocusClick = (e) => {
					let location = $(e.currentTarget).data('location');

					if (location) {
						this.set('justClickedLocationFocus', true);
						this.set('location', location);
						this.findComponent('c-location-input')?.fire('outsideLocationChange');
					}
				};

				$('body').on('click', '.popover-focus-loc', handleFocusClick);

				this.on('teardown', () => {
					$('body').off('click', '.popover-focus-loc', handleFocusClick);
					clearTimeout(this.probeCardTimeout);
				});
			}
		},
		getPopoverContent (locationValue, networkName = '') {
			let groupBy = this.get('groupBy');
			let targetLoc = '';

			if (networkName) {
				targetLoc = `${networkName}+${locationValue}`;
			} else {
				targetLoc = _.createLocationString(locationValue, this.get('location'));
			}

			let focusTargetText = 'location';

			if (groupBy === 'network') {
				focusTargetText = 'network';
			} else if (groupBy.includes('network') && networkName) {
				focusTargetText = 'location + network';
			}

			let btnFocus = `
				<button type="button"
					class="popover-focus-loc"
					data-location="${_.escapeLocationString(targetLoc)}">
					<i class="fa fa-map-marker" aria-hidden="true" style="padding-right: 3px;"></i>
					Focus this ${focusTargetText}
				</button>`;

			let btnMeasure = `
				<a href="/?location=${encodeURIComponent(targetLoc.replaceAll('+', '%'))}">
					<i class="fa fa-crosshairs" aria-hidden="true"></i>
					Target in a measurement
				</a>`;

			let btnLookingGlass = '';

			if (groupBy === 'network' || !!networkName) {
				networkName = networkName || locationValue;
				let networkKey = _.networkNameToKey(networkName);

				btnLookingGlass = `
				<a href="/networks/${networkKey}">
					<i class="fa fa-search" aria-hidden="true"></i>
					<span>
						<span class="gp-filtered-list_popover_network-name">${_.escapeLocationString(networkName)}</span>&nbsp;looking glass
					</span>
				</a>`;
			}

			return `<div class="gp-popover-menu">${btnFocus}${btnMeasure}${btnLookingGlass}</div>`;
		},
		getLocationCounts (probes) {
			let maps = probes.reduce((res, probe) => {
				res.countries.add(probe.location.country);
				res.cities.add(probe.location.country + probe.location.city);
				res.networks.add(probe.location.network);
				return res;
			}, {
				countries: new Set(),
				cities: new Set(),
				networks: new Set(),
			});

			return {
				countries: maps.countries.size,
				cities: maps.cities.size,
				networks: maps.networks.size,
			};
		},
		groupProbes (probes) {
			let groupBy = this.get('groupBy');
			// group probes by Continents and Coordinates
			let groups = probes.reduce((res, probe) => {
				let location = `${probe.location.country}, ${probe.location.city}`;

				let groupKey = groupBy === 'disabled' ? 'disabled' : probe.location.continent;

				if (groupBy === 'disabled') {
					if (!Object.hasOwn(res, groupKey)) {
						res[groupKey] = [];
					}

					res[groupKey].push(probe);
				} else {
					if (!Object.hasOwn(res, groupKey)) {
						res[groupKey] = {};
					}

					if (!Object.hasOwn(res[groupKey], location)) {
						res[groupKey][location] = [];
					}

					res[groupKey][location].push(probe);
				}

				return res;
			}, {});

			if (groupBy !== 'disabled') {
				let byContinentSorted = Object.entries(groups).sort((a, b) => Object.keys(b[1]).length - Object.keys(a[1]).length);
				groups = Object.fromEntries(byContinentSorted);
			}

			return groups;
		},
		getContinentName (code) {
			return CONTINENT_MAP[code] || code;
		},
		getCountryName (code) {
			return COUNTRIES_MAP[code] || code;
		},
		onLogoError (item) {
			item.logoAsn = null;
			this.update('preparedProbeBlocks');
		},
		sortAndGroup (obj) {
			let groupBy = this.get('groupBy');
			let sortOrder = this.get('sortOrder');

			if (groupBy === 'disabled') {
				return Object.values(obj).flat();
			}

			if (groupBy === 'network') {
				let allNetworks = {};

				Object.keys(obj).forEach((continent) => {
					let locations = Object.keys(obj[continent]);
					locations.forEach((location) => {
						let probes = obj[continent][location];
						probes.forEach((probe) => {
							let network = probe.location.network;
							let key = network.toLowerCase();

							if (!Object.hasOwn(allNetworks, key)) {
								allNetworks[key] = {
									name: network,
									probes: [],
								};
							}

							allNetworks[key].probes.push(probe);
						});
					});
				});

				let alphComp = (a, b) => allNetworks[a].name.localeCompare(allNetworks[b].name);
				let cntComp = (a, b) => allNetworks[b].probes.length - allNetworks[a].probes.length;

				let sortedNetworks = Object.keys(allNetworks).sort((a, b) => {
					if (sortOrder === 'alphabetically') {
						return alphComp(a, b) || cntComp(a, b);
					}

					return cntComp(a, b) || alphComp(a, b);
				});

				return sortedNetworks.map(network => ({
					continent: null,
					name: allNetworks[network].name,
					from: allNetworks[network].name,
					location: allNetworks[network].name,
					logoAsn: allNetworks[network].probes[0].location.asn,
					probes: allNetworks[network].probes,
					networks: [],
					showFlag: false,
				}));
			}

			let networkNameMap = {}; // make sure all networks have the same letter case across cities/countries

			let sortedArray = Object
				.keys(obj)
				.sort((a, b) => {
					if (sortOrder === 'alphabetically') {
						return a.localeCompare(b);
					}

					let probesCountA = Object.values(obj[a]).reduce((sum, probes) => sum + probes.length, 0);
					let probesCountB = Object.values(obj[b]).reduce((sum, probes) => sum + probes.length, 0);
					return probesCountB - probesCountA;
				})
				.reduce((acc, continent) => {
					let locations = Object.keys(obj[continent]);
					let groupedLocations = locations.reduce((acc, location) => {
						let probes = obj[continent][location];
						let key;

						switch (groupBy) {
							case 'country-network':
								key = probes[0].location.country;
								break;
							case 'city-network':
								key = `${probes[0].location.country}, ${probes[0].location.city}`;
								break;
							case 'city':
								key = `${probes[0].location.country}, ${probes[0].location.city}`;
								break;
							case 'country':
							default:
								key = probes[0].location.country;
								break;
						}

						if (!acc[key]) {
							acc[key] = [];
						}

						acc[key].push(...probes);
						return acc;
					}, {});

					let sortedLocations = Object.keys(groupedLocations).sort((a, b) => {
						if (sortOrder !== 'alphabetically') {
							return groupedLocations[b].length - groupedLocations[a].length;
						}

						let [ countryA, cityA ] = a.split(', ');
						let [ countryB, cityB ] = b.split(', ');

						let countryKeyA = groupBy.includes('country') ? this.getCountryName(countryA) : countryA;
						let countryKeyB = groupBy.includes('country') ? this.getCountryName(countryB) : countryB;

						return countryKeyA.localeCompare(countryKeyB) || (cityA && cityB ? cityA.localeCompare(cityB) : 0);
					});

					acc.push(...sortedLocations.map((location) => {
						let probes = groupedLocations[location];
						let networks = [];

						if (groupBy === 'country-network' || groupBy === 'city-network') {
							// Count probes per network
							let networkCounts = probes.reduce((acc, probe) => {
								let network = probe.location.network;
								let key = network.toLowerCase();

								if (!Object.hasOwn(networkNameMap, key)) {
									networkNameMap[key] = network;
								}

								if (!Object.hasOwn(acc, key)) {
									acc[key] = {
										name: networkNameMap[key],
										count: 0,
									};
								}

								acc[key].count += 1;
								return acc;
							}, {});

							networks = Object.entries(networkCounts).map(([ , { name, count }]) => ({
								name,
								count,
							}));

							if (sortOrder === 'alphabetically') {
								networks.sort((a, b) => a.name.localeCompare(b.name));
							} else {
								networks.sort((a, b) => b.count - a.count);
							}
						}

						let from;

						switch (groupBy) {
							case 'city':
							case 'city-network':
								from = `${probes[0].location.city}%${probes[0].location.country}`;
								break;
							case 'country-network':
							case 'country':
							default:
								from = this.getCountryName(probes[0].location.country);
								break;
						}

						return {
							continent,
							from,
							name: groupBy.startsWith('country') ? this.getCountryName(location) : location,
							location,
							probes,
							networks,
							showFlag: groupBy !== 'network',
						};
					}));

					return acc;
				}, []);

			return sortedArray;
		},
		splitDataIntoBlocks () {
			let groupedProbes = this.get('groupedProbes');

			if (!groupedProbes) {
				return [];
			}

			let data = this.sortAndGroup(groupedProbes);
			let groupBy = this.get('groupBy');

			if (groupBy === 'network' || groupBy === 'disabled') {
				return [{
					title: null,
					items: data,
				}];
			}

			return data.reduce((res, item) => {
				let continentGroup = res.find(group => group.title === item.continent);

				if (!continentGroup) {
					continentGroup = {
						title: item.continent,
						items: [],
					};

					res.push(continentGroup);
				}

				continentGroup.items.push(item);
				return res;
			}, []);
		},
		recalculateProbeContinents () {
			let groupBy = this.get('groupBy');
			let groupedProbes = this.get('groupedProbes');

			if (groupBy === 'disabled' || groupBy === 'network') {
				this.set('probeContinents', []);
				this.set('selectedContinent', null);
			} else {
				this.set('probeContinents', Object.keys(groupedProbes).map(continent => ({
					name: this.getContinentName(continent),
					value: continent,
				})));

				let selectedContinent = this.get('selectedContinent');
				this.set(
					'selectedContinent',
					this.get('probeContinents')
						.some(c => c.value === selectedContinent) ? selectedContinent : null,
				);
			}
		},
		scrollToContinent (continent) {
			let continentElement = document.getElementById(`probe-group-${continent}`);

			if (continentElement) {
				continentElement.scrollIntoView({ behavior: 'smooth' });
			}
		},
		resetFilters () {
			this.set('location', 'World');
			this.findComponent('c-location-input')?.fire('outsideLocationChange');
		},
		showAllProbeCards () {
			let blocks = this.get('preparedProbeBlocks');

			if (!blocks?.length) {
				return;
			}

			let allItems = blocks[0].items;
			let totalProbes = allItems.length;
			let originalLocation = this.get('location');

			this.set('loadingProbeCards', true);

			let increaseDisplayedProbeCount = () => {
				let currentVisibleCount = this.get('visibleProbeCards').length;

				if (currentVisibleCount >= totalProbes
					|| this.get('groupBy') !== 'disabled'
					|| this.get('location') !== originalLocation) {
					this.set('loadingProbeCards', false);
					return;
				}

				clearTimeout(this.probeCardTimeout);

				let nextProbeSet = allItems.slice(currentVisibleCount, currentVisibleCount + 100);

				this.push('visibleProbeCards', ...nextProbeSet);

				this.probeCardTimeout = setTimeout(() => {
					requestAnimationFrame(increaseDisplayedProbeCount);
				}, 10);
			};

			increaseDisplayedProbeCount();
		},
	};
</script>
